module.exports = __webpack_public_path__ + "static/BCAregistration-4fc73cf6a5e149f6d3961e9eecd7f9a7.svg";